import { useEffect } from "react";
import Tours from "../components/home/Tours";
import HowItWorks from "../components/home/HowItWorks";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import AOS from "aos";
import "aos/dist/aos.css";
import Menu from "../components/layout/Menu";
import Footer from "../components/layout/Footer";
const HomePage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // whether animation should happen only once
    });
  }, []);
  return (
  <>
  <Menu />
  <section className="sliderSec padSec overHide pb-0" id='top'>
    <div className=" text-left">
      <div className="sliderBg">
          <Swiper
          modules={[Navigation, Autoplay, EffectFade]}
          navigation={true}
          loop={true}
          effect="fade"
          speed={800}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          className="travelHeroSwiper"
        > 
        <SwiperSlide>

        <div className="sliderBgIn">
          <div className="sliderBgInIMG" style={{ backgroundImage: "url('/images/thailand2023.jpg')" }} ></div>

        <div className="sliderBgInOverlay"></div>
          <div className="container">
        <div className="sliderBgInWhite   text-md-start text-center w-md-50 ">

            <h1 >Welcome to the</h1>
            <h2> <span className="goldenText">Trust Bitcoin</span> Travel Portal</h2>
            <div className="">
            <p >The Trust Bitcoin Travel Portal is an exclusive platform for DAO achievers and community members who have earned luxurious international tour rewards through the Trust Bitcoin Ecosystem.</p>
            <p >Every trip here is a reward for achievement, fully verified and funded through blockchain smart contracts, ensuring complete fairness, transparency, and trust.</p>
            <p >Experience the world — powered by blockchain, guided by community.</p>
            <a href="/login" className="btn  blackbtn goldenbtn mt-3"><i className="fa-solid fa-plane me-2"></i> Dashboard <i className="fa-solid fa-arrow-right ms-3"></i></a>
          </div>
          </div>
        </div>
      </div>
        </SwiperSlide>
        <SwiperSlide>

        <div className="sliderBgIn">
          <div className="sliderBgInIMG" style={{ backgroundImage: "url('/images/indonasia.jpg')" }} ></div>

        <div className="sliderBgInOverlay"></div>
          <div className="container">
        <div className="sliderBgInWhite  text-md-start text-center w-md-50 ">

            <h1 >Welcome to the</h1>
            <h2> <span className="goldenText">Trust Bitcoin</span> Travel Portal</h2>
            <div className="">
            <p >The Trust Bitcoin Travel Portal is an exclusive platform for DAO achievers and community members who have earned luxurious international tour rewards through the Trust Bitcoin Ecosystem.</p>
            <p >Every trip here is a reward for achievement, fully verified and funded through blockchain smart contracts, ensuring complete fairness, transparency, and trust.</p>
            <p >Experience the world — powered by blockchain, guided by community.</p>
            <a href="/login" className="btn  blackbtn goldenbtn mt-3"><i className="fa-solid fa-plane me-2"></i> Dashboard <i className="fa-solid fa-arrow-right ms-3"></i></a>
          </div>
          </div>
        </div>
      </div>
        </SwiperSlide>
        <SwiperSlide>

        <div className="sliderBgIn">
          <div className="sliderBgInIMG" style={{ backgroundImage: "url('/images/singapore.jpg')" }} ></div>

        <div className="sliderBgInOverlay"></div>
          <div className="container">
        <div className="sliderBgInWhite text-md-start text-center w-md-50 ">

            <h1 >Welcome to the</h1>
            <h2> <span className="goldenText">Trust Bitcoin</span> Travel Portal</h2>
            <div className="">
            <p >The Trust Bitcoin Travel Portal is an exclusive platform for DAO achievers and community members who have earned luxurious international tour rewards through the Trust Bitcoin Ecosystem.</p>
            <p >Every trip here is a reward for achievement, fully verified and funded through blockchain smart contracts, ensuring complete fairness, transparency, and trust.</p>
            <p >Experience the world — powered by blockchain, guided by community.</p>
            <a href="/login" className="btn  blackbtn goldenbtn mt-3"><i className="fa-solid fa-plane me-2"></i> Dashboard <i className="fa-solid fa-arrow-right ms-3"></i></a>
          </div>
          </div>
        </div>
      </div>
        </SwiperSlide>
      </Swiper>
      </div>
    </div>
  </section>
  
  <Tours/>

  {/*<section className=" padSec overHide pt-0" id='about'>
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="sbcontent d-flex align-items-center gap-3 mb-2">
            <div className=" order-md-2">
              <h4>Our Mission</h4>
              <p className="mb-1">To give every Trust Bitcoin Community Member a chance to see the world —  rewarded by their contribution, powered by decentralization.</p>
              <p className="mb-1"><b>“Blockchain Rewards, Real-World Experiences.”</b></p>
            </div>
            <div className="img order-md-1">
              <img src="/images/mission.svg" className="img-fluid" style={{width:'180px'}} />
            </div>
          </div>
        </div>
        <div className="col-md-6" id='commitment'>
          <div className="sbcontent d-flex align-items-center gap-3 mb-2">
            <div>
              <h4>Transparency Commitment</h4>
              <ul>
<li>100% DAO-controlled tour incentives</li>
<li>8% + 12% on-chain distribution visible to all members</li>
<li>No manual processing or centralized control</li>
<li>Timely reports published on www.trustbitcoin.io/transparency</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>*/}
  <HowItWorks/>
  <section className="partnerContentSec padSec overHide pt-0" id='#'>
    <div className="container">
      <div className="blurbg text-center ">
        <div className="workSectionHead w-100">
        <h2>Partner Travel Companies</h2>
        <p>All tours are executed through licensed travel agencies registered under DMCC or various govt.<br/>Authorities through out the world and approved by DAO governance.<br/>The DAO ensures every travel partner is compliant with local tourism laws and verified under the DAO’s partnership smart contract.</p>
      </div>
      </div>
    </div>
  </section>
  {/*<section className="fundingSec padSec overHide pt-0" id='funding'>
    <div className="container">
      <div className="tBG">
        <h3>DAO-Powered Funding</h3>
      <div className="table-responsive table-fluid">
        <table className="table table-light text-start">
          <thead>
            <tr>
              <th>Source</th>
              <th>Contribution</th>
              <th>Purpose</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Achiever Wallet</th>
              <td>8%</td>
              <td>Community fund contribution for global tours</td>
            </tr>
            <tr>
              <th>Total</th>
              <td>20%</td>
              <td>Complete travel fund (flights, accommodation, activities)</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
  </section>*/}

  <Footer />
  </>
  );
};

export default HomePage;